//Limitless imports
import { log as pilog } from "@limitless/common/utils";
import { useExpertTaskListContext } from "./ExpertTaskListContext";
export const INITIAL_TASKLIST_FILTERS_STATE = {
  taskType: {
    new: {
      label: "New",
      value: false,
      filterValue: "respondNew",
      visible: true,
      filtertType: "tasktype",
      id: "new",
      info: "New - Tasks which have not yet received a response from an Expert.",
      filter: messageInbox => ["new", "respondNew", "respondSticky"].includes(messageInbox.type)
    },
    respond: {
      label: "Respond",
      value: false,
      filterValue: "respondExisting",
      visible: true,
      filtertType: "tasktype",
      id: "respond",
      info: "Respond – Tasks in which an Expert has already responded but the customer has replied and now requires a further response from an Expert.",
      filter: messageInbox => ["respondSticky", "respondExisting", "respond"].includes(messageInbox.type)
    },
    respondSticky: {
      label: "Pass",
      value: false,
      visible: false,
      info: "Assigned Task - Tasks which you have previously worked on where you have exclusive access for a set period of time to continue the conversation with the customer.",
      filterValue: "respondSticky",
      filtertType: "tasktype",
      id: "passedTasks",
      filter: messageInbox => messageInbox.passed
    },
    reviewEscalation: {
      label: "Forward Review",
      value: false,
      filterValue: "reviewEscalation",
      visible: true,
      filtertType: "tasktype",
      id: "reviewEscalation",
      info: "Forward Review – An Expert has decided this task needs to be forwarded to the client's Customer Service team. It needs to be reviewed and agreed before this happens.",
      filter: messageInbox => ["respondSticky", "reviewEscalation"].includes(messageInbox.type)
    },
    review: {
      label: "Peer Review",
      value: false,
      filterValue: "reviewFee",
      visible: true,
      filtertType: "tasktype",
      id: "review",
      info: "Peer Review – Tasks which have already been answered by other Experts and are currently waiting to be peer-reviewed. Not all brands have peer reviews.",
      filter: messageInbox => ["respondSticky", "reviewFee", "review"].includes(messageInbox.type)
    },
    reviewDetailed: {
      label: "Quality Review",
      value: false,
      filterValue: "reviewQuality",
      visible: false,
      filtertType: "tasktype",
      id: "reviewDetailed",
      info: "Quality Review – Tasks which have been answered by other Experts and require a quality review by a Gig Guide.",
      filter: messageInbox => ["respondSticky", "reviewQuality", "reviewDetailed"].includes(messageInbox.type)
    }
  },
  passedTasks: {
    pass: {
      label: "Pass",
      value: false,
      filtertType: "tasktype",
      id: "passedTasks",
      filter: messageInbox => messageInbox.passed
    }
  },
  passed: false,
  selectedGroups: {
    value: [],
    filtertType: "selectedGroups",
    filter: (messageInbox, values) => values.find(v => v.label === messageInbox.groupName)
  },
  checkedFilters: [],
  addFilter: [],
  removedFilter: [],
  selectedFilters: [],
  isFilterSelected: false,
  taskFee: {
    minFee: "",
    maxFee: ""
  },
  pristine: true
};
export const useTaskListFilter = () => {
  // Use State to keep the values

  const log = pilog.getLogger("useTaskListFilter");
  const {
    tasklist,
    tasklistFilters,
    setTasklistFilters,
    resetFiltersAndFetchTaskList,
    applyFilters,
    resetFilters
  } = useExpertTaskListContext();
  const calculateFilterSelected = filters => {
    var _filters$selectedGrou;
    log.debug(filters);
    let isFilterSelected = false;
    if ((filters === null || filters === void 0 ? void 0 : (_filters$selectedGrou = filters.selectedGroups) === null || _filters$selectedGrou === void 0 ? void 0 : _filters$selectedGrou.value.length) !== 0) {
      isFilterSelected = true;
    } else {
      if (filters.taskType.review.value || filters.taskType.respond.value || filters.taskType.new.value || filters.taskType.reviewDetailed.value || filters.taskType.reviewEscalation.value || filters.passedTasks.pass.value) {
        isFilterSelected = true;
      }
    }
    filters.isFilterSelected = isFilterSelected;
    setTasklistFilters(filters);
  };
  const resetUIFilters = () => {
    tasklistFilters.taskType.respond.value = false;
    tasklistFilters.taskType.respond.value = false;
    tasklistFilters.taskType.review.value = false;
    tasklistFilters.taskType.new.value = false;
    tasklistFilters.isFilterSelected = false;
    tasklistFilters.selectedGroups.value = [];
    tasklistFilters.taskType.reviewDetailed.value = false;
    tasklistFilters.taskType.reviewEscalation.value = false;
    tasklistFilters.selectedFilters = [];
    tasklistFilters.selectedGroups.value = [];
    tasklistFilters.checkedFilters = [];
    tasklistFilters.addFilter = [];
    tasklistFilters.removedFilter = [];
    tasklistFilters.passed = false;
    tasklistFilters.taskFee = {
      minFee: "",
      maxFee: ""
    };
    return tasklistFilters;
  };
  const setTaskTypeFilters = (name, newValue) => {
    const newTaskTypeFilter = {
      ...tasklistFilters.taskType
    };
    newTaskTypeFilter[name].value = newValue;
    calculateFilterSelected({
      ...tasklistFilters,
      taskType: newTaskTypeFilter
    });
  };
  const setPassedTasksFilters = newValue => {
    calculateFilterSelected({
      ...tasklistFilters,
      passedTasks: {
        pass: {
          ...tasklistFilters.passedTasks.pass,
          value: newValue
        }
      }
    });
  };
  const setSelectedGroups = (newGroups, checkGroups = [], removedGroups = []) => {
    let updatedCheckedFilters = newGroups.length === 0 && tasklistFilters.selectedFilters.length > 0 ? [...tasklistFilters.checkedFilters, {
      name: "selectedGroups",
      value: newGroups
    }] : newGroups.length === 0 ? tasklistFilters.checkedFilters.filter(filter => filter.name !== "selectedGroups") : [...tasklistFilters.checkedFilters.filter(filter => filter.name !== "selectedGroups"), {
      name: "selectedGroups",
      value: newGroups
    }];
    const tenantExist = tasklistFilters.selectedFilters.some(item => removedGroups.some(data => item.tenantName === data.tenantName));

    //check each states seperaltely

    // Remove the "selectedGroups" filter if removedGroups is not empty
    if (removedGroups.length > 0 && tenantExist) {
      updatedCheckedFilters = [...tasklistFilters.checkedFilters, {
        name: "selectedGroups",
        value: newGroups
      }];
    }
    if (tenantExist && removedGroups.length > 1) {
      updatedCheckedFilters = [...tasklistFilters.checkedFilters, {
        name: "selectedGroups",
        value: newGroups
      }];
    }
    if (tasklistFilters.removedFilter.length > 1 && checkGroups.length > 0) {
      updatedCheckedFilters = [...tasklistFilters.checkedFilters, {
        name: "selectedGroups",
        value: newGroups
      }];
    }
    if (process.env.REACT_APP_NAME === "ExpertWebApp") {
      var _tasklistFilters$addF;
      const checkAvailabilty = tasklistFilters === null || tasklistFilters === void 0 ? void 0 : tasklistFilters.selectedFilters.some(item1 => checkGroups.some(item2 => item2.groupName === item1.groupName && item2.tenantName === item1.tenantName));
      const filterExist = tasklistFilters === null || tasklistFilters === void 0 ? void 0 : (_tasklistFilters$addF = tasklistFilters.addFilter) === null || _tasklistFilters$addF === void 0 ? void 0 : _tasklistFilters$addF.filter(item => checkGroups === null || checkGroups === void 0 ? void 0 : checkGroups.some(item1 => (item === null || item === void 0 ? void 0 : item.groupName) === (item1 === null || item1 === void 0 ? void 0 : item1.groupName) && (item === null || item === void 0 ? void 0 : item.tenantName) === (item1 === null || item1 === void 0 ? void 0 : item1.tenantName)));
      if (checkAvailabilty && checkGroups.length === 1) {
        updatedCheckedFilters = updatedCheckedFilters.filter(filter => filter.name !== "selectedGroups");
      }
      if (!checkAvailabilty && checkGroups.length === 1) {
        updatedCheckedFilters = [...tasklistFilters.checkedFilters, {
          name: "selectedGroups",
          value: newGroups
        }];
      }
      if (removedGroups.length === 1 && checkAvailabilty) {
        updatedCheckedFilters = [...tasklistFilters.checkedFilters, {
          name: "selectedGroups",
          value: newGroups
        }];
      }
      if (checkAvailabilty && removedGroups.length > 1) {
        updatedCheckedFilters = updatedCheckedFilters.filter(filter => filter.name !== "selectedGroups");
      }
      if ((filterExist === null || filterExist === void 0 ? void 0 : filterExist.length) > 0) {
        updatedCheckedFilters = [...tasklistFilters.checkedFilters, {
          name: "selectedGroups",
          value: newGroups
        }];
      }
    }
    calculateFilterSelected({
      ...tasklistFilters,
      selectedGroups: {
        ...tasklistFilters.selectedGroups,
        value: newGroups
      },
      checkedFilters: updatedCheckedFilters,
      removedFilter: removedGroups.length === 0 ? tasklistFilters.removedFilter : removedGroups,
      addFilter: checkGroups
    });
  };
  const setPassedTaskFilter = isPassed => {
    setTasklistFilters({
      ...tasklistFilters,
      passed: isPassed
    });
  };
  const setFeeFilters = (key, value) => {
    const updatedTaskFee = {
      ...tasklistFilters.taskFee,
      [key]: value
    };
    const updatedFilters = updatedTaskFee.minFee === 0 && updatedTaskFee.maxFee === 0 ? tasklistFilters.checkedFilters.filter(filter => filter.name !== "taskFee") : [...tasklistFilters.checkedFilters.filter(filter => filter.name !== "taskFee"), {
      name: "taskFee",
      minFee: updatedTaskFee.minFee,
      maxFee: updatedTaskFee.maxFee
    }];
    setTasklistFilters({
      ...tasklistFilters,
      taskFee: updatedTaskFee,
      checkedFilters: updatedFilters,
      isFilterSelected: updatedFilters.length > 0
    });
  };
  const clearFilter = () => {
    resetUIFilters();
  };
  const clearExpertTaskFilters = () => {
    resetFiltersAndFetchTaskList();
    calculateFilterSelected(resetUIFilters());
  };
  const renderFilterLabel = (translate, count) => {
    if (count === 1) {
      return translate("filter applied", count);
    } else if (count > 1) {
      return translate("filters applied", count);
    }
  };

  // Make the context object:
  return {
    tasklistFilters,
    setTaskTypeFilters,
    setPassedTasksFilters,
    setSelectedGroups,
    applyFilters,
    clearExpertTaskFilters,
    clearFilter,
    renderFilterLabel,
    setFeeFilters,
    setPassedTaskFilter,
    setTasklistFilters
  };
};